import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

function debounce(delay = 300) {
    return (target, propertyKey, descriptor) => {
        let timeout = null;
        const original = descriptor.value;
        descriptor.value = function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => original.apply(this, args), delay);
        };
        return descriptor;
    };
}

function throttle(delay) {
    return (target, propertyKey, descriptor) => {
        let isThrolled = false;
        let savedArgs;
        let savedThis;
        const original = descriptor.value;
        function wrapper(...arg) {
            if (isThrolled) {
                savedArgs = arg;
                savedThis = this;
                return;
            }
            original.apply(this, arg);
            isThrolled = true;
            setTimeout(function () {
                isThrolled = false;
                if (savedArgs) {
                    wrapper.apply(savedThis, savedArgs);
                    savedArgs = savedThis = null;
                }
            }, delay);
        }
        descriptor.value = wrapper;
        return descriptor;
    };
}

class DecoratorService {
    static { this.injected = false; }
    constructor(_platformId) {
        this._platformId = _platformId;
        DecoratorService.platformId = this._platformId;
        DecoratorService.injected = true;
    }
    static isBrowser() {
        this.checkService();
        return isPlatformBrowser(this.platformId);
    }
    static isServer() {
        this.checkService();
        return isPlatformServer(this.platformId);
    }
    static checkService() {
        if (!this.injected) {
            throw new Error('ProvidedIn needs to service injection');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DecoratorService, deps: [{ token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DecoratorService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DecoratorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

function browserMethod() {
    return (target, propertyKey, descriptor) => {
        const original = descriptor.value;
        descriptor.value = function (...args) {
            if (!DecoratorService.isBrowser()) {
                return;
            }
            return original.apply(this, args);
        };
        return descriptor;
    };
}

function serverMethod() {
    return (target, propertyKey, descriptor) => {
        const original = descriptor.value;
        descriptor.value = function (...args) {
            if (!DecoratorService.isServer()) {
                return;
            }
            return original.apply(this, args);
        };
        return descriptor;
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { DecoratorService, browserMethod, debounce, serverMethod, throttle };
